import moment from "moment";
import apis from "../../../api";
import { errorTypes } from "../../../utils/errorTypes";
import { distribute } from "../../../utils/mainTabs/distribute/distribute";
import {
  setAllClassNamesAction,
  setCertificateByProgramIdAction,
  setCollectionDataAction,
  setSelectedSeriesDataAction,
  setSelectedShotclassDataAction,
  setSeriesDataAction,
  setShotclassDataAction,
} from "../actionCreators/distributeActionCreator";
import loaders from "../actionCreators/loadersActionCreator";
import { setErrorHandler } from "./errorActionHandler";

export const getAllProgramsActionHandler =
  (Condition, Status, ShotClass, setData) => async () => {
    await apis.distribute
      .getAllProgramsCount(Condition, Status, ShotClass)
      .then((response) => {
        if (response) {
          setData(response?.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getShotClassesActionHandler =
  (
    Condition,
    Isdistributefilter,
    Status,
    classtype,
    filters,
    locale,
    pageNum,
    pageSize,
    setLoader
  ) =>
  async (dispatch, getState) => {
    if (pageNum === 1) setLoader(true);
    await apis.distribute
      .getShotClasses(
        Condition,
        Isdistributefilter,
        Status,
        classtype,
        filters,
        locale,
        pageNum,
        10
      )
      .then((response) => {
        if (response) {
          if (classtype === "ShotClass") {
            const shotclassData = getState().distributeReducer?.shotclassData;
            const allshotclassData = [...shotclassData, ...response?.data];
            const selectedShotclassData =
              getState().distributeReducer?.selctedShotclassData;
            if (selectedShotclassData?.length) {
              const selectedShotclassDataIds =
                getState()?.distributeReducer?.selctedShotclassData?.map(
                  (data) => {
                    return data?.ID;
                  }
                );
              const updatedData = allshotclassData?.map((data) => {
                if (selectedShotclassDataIds?.includes(data?.ShotClass?.ID))
                  return {
                    ...data,
                    ShotClass: { ...data.ShotClass, checked: true },
                  };
                else return { ...data };
              });
              dispatch(setShotclassDataAction(updatedData));
            } else dispatch(setShotclassDataAction(allshotclassData));
            if (pageNum === 1) setLoader(false);
          } else if (classtype === "Program") {
            const seriesData = getState().distributeReducer?.seriesData;
            const allSeriesData = [...seriesData, ...response?.data];
            const selectedSeriesData =
              getState().distributeReducer?.selctedSeriesData;
            if (selectedSeriesData?.length) {
              const selectedSeriesDataIds =
                getState()?.distributeReducer?.selctedSeriesData?.map(
                  (data) => {
                    return data?.ID;
                  }
                );
              const updatedData = allSeriesData?.map((data) => {
                if (selectedSeriesDataIds?.includes(data?.Programs?.ID))
                  return {
                    ...data,
                    Programs: { ...data.Programs, checked: true },
                  };
                else return { ...data };
              });
              dispatch(setSeriesDataAction(updatedData));
            } else dispatch(setSeriesDataAction(allSeriesData));
          } else {
            const collectionData = getState().distributeReducer?.collectionData;
            dispatch(
              setCollectionDataAction([...collectionData, ...response?.data])
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getDistributionHistoryActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setDistributionHistoryData,
    setTempDistributionHistoryData,
    setTotalRows
  ) =>
  async () => {
    await apis.distribute
      .getDistributionHistory(pageSize, pageNumber)
      .then((response) => {
        if (response) {
          setDistributionHistoryData((prevStateData) => [
            ...prevStateData,
            ...response.data.Content,
          ]);
          setTempDistributionHistoryData((prevStateData) => [
            ...prevStateData,
            ...response.data.Content,
          ]);
          setTotalRows(response?.data?.TotalRows);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getSearchShotclassesActionHandler =
  (
    IsDistributed,
    IsPartOfProgram,
    SearchText,
    Status,
    setData,
    setSearchLoader
  ) =>
  async () => {
    setSearchLoader(true);
    await apis.distribute
      .getSearchShotclasses(IsDistributed, IsPartOfProgram, SearchText, Status)
      .then((response) => {
        if (response) {
          const updatedData = response?.data?.Content?.map((data) => {
            return { ...data, id: data?.ID, val: data?.Name };
          });
          setData(updatedData);
          setSearchLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getUserClassAssignmentActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUserClassAssignmentData,
    setTempUserClassAssignmentData,
    setTotalRows,
    selectedUserClassAndNameObj
  ) =>
  async () => {
    console.log(selectedUserClassAndNameObj);
    await apis.distribute
      .getUserClassAssignment(
        selectedUserClassAndNameObj?.classId,
        pageNumber,
        pageSize,
        selectedUserClassAndNameObj?.fromDate
          ? encodeURIComponent(
              moment(selectedUserClassAndNameObj?.fromDate).format("DD/MM/YYYY")
            )
          : null,
        selectedUserClassAndNameObj?.toDate
          ? encodeURIComponent(
              moment(selectedUserClassAndNameObj?.toDate).format("DD/MM/YYYY")
            )
          : null,
        selectedUserClassAndNameObj?.userId,
        selectedUserClassAndNameObj?.type
      )
      .then((response) => {
        if (response) {
          setUserClassAssignmentData((prevStateData) => [
            ...prevStateData,
            ...response.data,
          ]);
          setTempUserClassAssignmentData((prevStateData) => [
            ...prevStateData,
            ...response.data,
          ]);
          setTotalRows(
            selectedUserClassAndNameObj?.type === "class"
              ? response?.data?.[0]?.ToatalCount
              : response?.data?.[0]?.TotalCount
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const putAssignedClassesActionHandler = (data) => async () => {
  return await apis.distribute
    .putAssignedClasses(data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const archiveClassesActionHandler = (data) => async () => {
  return await apis.distribute
    .archiveClasses(data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getUserByNameActionHandler =
  (SearchText, Status, setData, setSearchLoader) => async () => {
    setSearchLoader(true);
    return await apis.distribute
      .getUserByName(SearchText, Status)
      .then((response) => {
        if (response) {
          const updatedData = response?.data?.map((data) => {
            return {
              ...data,
              id: data?.ID,
              val: data?.FirstName + " " + data?.LastName,
            };
          });
          setData(updatedData);
          setSearchLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getProgramDistributionHistoryActionHandler =
  (programId, setData, setLoader) => async () => {
    setLoader(true);
    return await apis.distribute
      .getProgramDistributionHistory(programId)
      .then((response) => {
        if (response) {
          const updatedData = response?.data?.map((data, index) => {
            return { ...data, Id: index };
          });
          setData(updatedData);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const deleteProgramActionHandler =
  (programId, setData, setLoader) => async (dispatch) => {
    setLoader(true);
    return await apis.distribute
      .deleteProgram(programId)
      .then((response) => {
        if (response) {
          setData(response?.data);
          setLoader(false);
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              "Series has been deleted successfully"
            )
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const deleteCollectionActionHandler =
  (CollectionID, setData, setLoader) => async () => {
    setLoader(true);
    return await apis.distribute
      .deleteCollection(CollectionID)
      .then((response) => {
        if (response) {
          setData(response?.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getUserGroupsHandler = (setData, setLoader) => async () => {
  setLoader(true);
  await apis.social
    .getPollUserGroup()
    .then((response) => {
      if (response.data) {
        const updatedData = response.data.UserGroups.map((data) => {
          return {
            ...data,
            isVisible: true,
          };
        });
        setData(updatedData);
        setLoader(false);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getUserGroupsForForumTopicHandler = () => async () => {
  // setLoader(true);
  return await apis.social
    .getPollUserGroup()
    .then((response) => {
      return response;
      // if (response.data) {
      //   const updatedData = response?.data?.UserGroups?.map((item) => {
      //     return { ...item, isVisible: true };
      //   });
      //   setData(updatedData);
      //   setLoader(false);
      // }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const distributeClassesActionHandler =
  (data, setLoader, navigate, tenantName, setLoading) => async (dispatch) => {
    setLoader(true);
    await apis.distribute
      .distributeClasses(data)
      .then((response) => {
        if (response.data) {
          dispatch(
            setErrorHandler(
              errorTypes?.SUCCESS,
              "Classes/Series distributed Successfully"
            )
          );
          navigate(distribute?.classPath(tenantName));
          dispatch(setShotclassDataAction([]));
          dispatch(setSeriesDataAction([]));
          dispatch(setSelectedShotclassDataAction([]));
          dispatch(setSelectedSeriesDataAction([]));
          dispatch(
            getShotClassesActionHandler(
              "WithoutVTLT",
              false,
              "Published",
              "ShotClass",
              "none",
              "none",
              1,
              10,
              setLoading
            )
          );
          dispatch(
            getShotClassesActionHandler(
              "WithoutVTLT",
              false,
              "Published",
              "Program",
              "none",
              "none",
              1,
              10,
              setLoading
            )
          );
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getWorkOrOfficeLocationListActionHandler =
  () => async (dispatch) => {
    dispatch(loaders.admin.userManagement.getWorkOfficeListLoader(true));
    return await apis.distribute
      .getWorkOrOfficeLocationList()
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.admin.userManagement.getWorkOfficeListLoader(false));
      });
  };
export const getStoreListByStoreIdActionHandler = (StoreId) => async () => {
  return await apis.distribute
    .getStoreListByStoreId(StoreId)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getStoreListByCountryIdActionHandler = (CountryId) => async () => {
  return await apis.distribute
    .getStoreListByCountryId(CountryId)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getUsersActionHandler =
  (setData, setLoader, setOriginalSetOfUsers) => async () => {
    setLoader(true);
    await apis.reports.common
      .getTenantUsers()
      .then((response) => {
        const updatedData = response?.data?.map((item) => {
          return {
            ...item,
            Name: item?.FirstName + " " + item?.LastName,
            isVisible: true,
            checked: false,
          };
        });
        setData(updatedData);
        setOriginalSetOfUsers(updatedData);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const postCollectionActionHandler =
  (data, setLoader, setIsCreateCollectionModal) => async (dispatch) => {
    setLoader(true);
    await apis.distribute
      .postCollection(data)
      .then((response) => {
        if (response.data) {
          dispatch(setErrorHandler(errorTypes.SUCCESS, response.data));
          setLoader(false);
          setIsCreateCollectionModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const isCollectionNameExistsActionHandler =
  (searchText, setLoader, setDuplicateNameError, type) => async () => {
    setLoader(true);
    await apis.manage
      .isNameExists(searchText, type)
      .then((response) => {
        if (response.data) {
          setDuplicateNameError("This name is already exist.");
          setLoader(false);
        } else {
          setDuplicateNameError("");
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getCertificateActionHandler = (setLoader, setData) => async () => {
  setLoader(true);
  await apis.distribute
    .getCertificate()
    .then((response) => {
      if (response.data) {
        setLoader(false);
        setData(response.data);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const postCertificateActionHandler = (data) => async () => {
  await apis.distribute
    .postCertificate(data)
    .then((response) => {
      if (response.data) {
        console.log(response?.data);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getCertificateByProgramIdActionHandler =
  (programId) => async (dispatch) => {
    await apis.distribute
      .getCertificateByProgramId(programId)
      .then((response) => {
        if (response.data) {
          dispatch(setCertificateByProgramIdAction(response?.data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getCertificateByProgramIdOrganizeActionHandler =
  (programId) => async (dispatch) => {
    return await apis.distribute
      .getCertificateByProgramId(programId)
      .then((response) => {
        dispatch(setCertificateByProgramIdAction(response?.data));
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const searchProgramDistributeActionHandler =
  (SearchText, Status, locale, condition) => async () => {
    return await apis.organize
      .searchSeriesProgram(SearchText, Status, locale, condition)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getClassByStatusWithConditionActionHandler =
  (Condition, Status, pageNum, pageSize, setAllClassNames) =>
  async (dispatch, getState) => {
    await apis.distribute
      .getClassByStatusWithCondition(Condition, Status, pageNum, pageSize)
      .then((response) => {
        if (response) {
          response?.data?.Content?.forEach((data) => {
            const allClassNames =
              getState()?.distributeReducer?.originalAllClassNames;
            dispatch(setAllClassNamesAction([...allClassNames, data?.Name]));
            setAllClassNames((prevState) => {
              return [...prevState, data?.Name];
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getAllPublishedByMeClassnamesActionHandler =
  (
    Condition,
    Status,
    classtype,
    filters,
    locale,
    pageNum,
    pageSize,
    setAllClassNames
  ) =>
  async (dispatch, getState) => {
    await apis.distribute
      .getAllPublishedByMeClassnames(
        Condition,
        Status,
        classtype,
        filters,
        locale,
        pageNum,
        pageSize
      )
      .then((response) => {
        if (response) {
          response?.data?.Content?.forEach((data) => {
            const allClassNames =
              getState()?.distributeReducer?.originalAllClassNames;
            dispatch(setAllClassNamesAction([...allClassNames, data?.Name]));
            setAllClassNames((prevState) => {
              return [...prevState, data?.Name];
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
